import { FC } from "react";
import billingsTaxiUnbilledRouteListingFiltersBadgeListHelper from "./billings-taxi-unbilled-route-listing-filters-badge-list.helper";
import BillingsTaxiUnbilledRouteListingFilter from "../../types/billings-taxi-unbilled-route-listing-filter";
import ListingFilterBadgeListComponent from "../../../../../../../common/components/listing/filter/badge-list/listing-filter-badge-list.component";

type BillingsTaxiUnbilledRouteListingFiltersListProps = {
  filters: BillingsTaxiUnbilledRouteListingFilter[];
  onDeleteFilterClick: (filterIndex: number) => void;
  onDeleteAllFiltersButtonClick: () => void;
};

const BillingsTaxiUnbilledRouteListingFiltersBadgeListComponent: FC<
  BillingsTaxiUnbilledRouteListingFiltersListProps
> = (props) => {
  const badges =
    billingsTaxiUnbilledRouteListingFiltersBadgeListHelper.getBadges(
      props.filters
    );

  return (
    <ListingFilterBadgeListComponent
      badges={badges}
      onDeleteAll={props.onDeleteAllFiltersButtonClick}
      onDelete={props.onDeleteFilterClick}
    />
  );
};

export default BillingsTaxiUnbilledRouteListingFiltersBadgeListComponent;
